import React, {
  createContext,
  type FC,
  type ReactNode,
  useContext,
} from "react";

interface DatameshNamespaceProviderProps {
  namespace: string;
  children: ReactNode;
}

export const DatameshNamespaceContext = createContext<string>("");

const DatameshNamespaceProvider: FC<DatameshNamespaceProviderProps> = ({
  namespace,
  children,
}) => {
  return (
    <DatameshNamespaceContext.Provider value={namespace}>
      {children}
    </DatameshNamespaceContext.Provider>
  );
};

export const useDatameshNamespace = () => useContext(DatameshNamespaceContext);

export default DatameshNamespaceProvider;
